import React from 'react';
import {
  LayoutDashboard,
  Megaphone,
  Sparkles,
  CreditCard,
  FileText,
  Sheet,
  MessageCircle,
  FileBarChart,
  Shield,
  Calendar as CalendarIcon,
} from 'lucide-react';

export const getNavIcon = (iconName: string, className: string = 'h-5 w-5'): React.ReactElement => {
  switch (iconName) {
    case 'dashboard': return <LayoutDashboard className={className} />;
    case 'megaphone': return <Megaphone className={className} />;
    case 'sparkles': return <Sparkles className={className} />;
    case 'credit-card': return <CreditCard className={className} />;
    case 'file-text': return <FileText className={className} />;
    case 'sheet': return <Sheet className={className} />;
    case 'whatsapp': return <MessageCircle className={className} />;
    case 'message-circle': return <MessageCircle className={className} />;
    case 'report': return <FileBarChart className={className} />;
    case 'admin': return <Shield className={className} />;
    case 'calendar': return <CalendarIcon className={className} />;
    default: return <LayoutDashboard className={className} />;
  }
};
